import React, { Fragment } from "react";
import DataGrid from '@dataGrid';
import StopsGridConfig from "./StopsGridConfig";
import { observer, inject } from "mobx-react";
import appConstant from "../../../../appConstants";
import MESSAGES from "../../../../appMessages";
import { cloneDeep, isEqual } from "lodash/lang";
import { autorun, reaction } from "mobx";
import { withStyles, withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { postData } from "../../../../api/componentAPIs";
import { withSnackbar } from "notistack";
import StopMoveFeedbackPanel from "./StopMoveFeedbackPanel";
import { StopStatusCellRenderer } from '@dataGrid/components/cellRenderer/index';
import StatusBar from '@dataGrid/components/StatusBar';
import CheckViolation from "../../../common/checkViolation";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import { withFeatureFlags } from "../../../../userProfile/featureFlagsContext";
import MergeStopAlert from "../Common/MergeStops/MergeStopAlert";
import { MapHelper } from "../../../../lib/Map/index";
import MergeStops from "../Common/MergeStops/index";
import { withAppConfig } from "../../../../appConfigContext";
import { getSpecialNeedsOptionsWithServiceLevel } from "../../utils";
import { MERGE_TYPES, isPickupStop, isDeliveryStop } from "../Common/MergeStops/utills"
import { isAnchorPointEquipmentMismatch, isEquipmentMismatch } from "./utils";
import { v4 as uuidv4 } from "uuid";
import withMapConfig from "@withMapConfig";
import { handleWhiteGloveProMove } from "../Common/whiteGloveRouteUtils";

const styles = theme => ({
    highlightText:{
        color: theme.HeaderSelectedText
    }
})
@inject("IBPlanningStore", "CommonStore")
@observer
class StopsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new StopsGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      featureFlags: {
        IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.isWeightBasedRouting
        ),
        IsStopTimeEditable: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.IsStopTimeEditable
        ),
      },
      ROUTENAME_EDITOR_PARAMS: this.props.configJSON?.routeNameEditParams,
      shouldShowTwoManInTrailerInventory: this.props.configJSON.shouldShowTwoManInTrailerInventory,
      enableNoCargoVanCustomer: this.props.configJSON.enableNoCargoVanCustomer,
      enableFixedEquipmentSize: this.props.configJSON.enableFixedEquipmentSize,
      enableRevenueFieldsOnUI: this.props.configJSON.enableRevenueFieldsOnUi
    });
    this.stopSelectedOnGrid = true;
    this.state = {
      quickFilterText: "",
      filterData: "",
      selectedStops: null,
      showMergeStopAlert: false,
      mergeStopInProgress: false,
    };
    this.selectedRoute = null;
    this.feedbackPanelKey = null;
    this.intialSequenceState = {};
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
    this.maxWaitingTimeAtStop = this.props.CommonStore.maxWaitingTimeAtStop;
    this.gridContext = {
      newShipments: this.props.IBPlanningStore.newShipments,
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.serviceLevelList, [], appConstant.gridNames.StopsGrid),
      hasEquipmentMismatch: this.hasEquipmentMismatch,
      hasAnchorPointEquipmentMismatch: this.hasAnchorPointEquipmentMismatch,
      maxWaitingTimeAtStop: this.props.CommonStore.maxWaitingTimeAtStop,
      enableFMECustomer: this.props.configJSON?.enableFMECustomer,
      enableTailLoad: this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement),
      routesList: this.props.IBPlanningStore.routesList,
      planDate :this.props.userData.userProfile.planDate,
      getTrailerNameForRoute: this.props.IBPlanningStore.getTrailerNameForRoute,
      getTrailerInfo: this.props.CommonStore.getTrailerInfo,
    };
    this.gridApi = {};
    this.isPickupStopMergeFlow = false;
    this.isDragOperationInProgress = false;
  }
  componentDidMount() {
    this.props.glEventHub.on(
      appConstant.Event.STOP_SELECTED_MAP,
      this.stopSelected
    );
    this.props.glEventHub.on(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.on(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_mergeStops`,
      this.confirmMergeStop
    );
    this.autorunNewShipmentsDispose = autorun(() => {
      if (this.props.IBPlanningStore.newShipments.data?.slice()) {
        this.refreshViolationColumn();
      }
    });

    this.updateDragStateDispose = autorun(() => {
      if (
        [true, false].includes(this.props.IBPlanningStore.disableStoreUpdate)
      ) {
        this.updateGridRowDragState(
          this.props.IBPlanningStore.disableStoreUpdate
        );
      }
    });

    this.autorunPriorityShipmentList = autorun(() => {
      if (
        !isEqual(
          this.serviceLevelList,
          this.props.IBPlanningStore.serviceLevelList
        )
      ) {
        this.serviceLevelList = this.props.IBPlanningStore.serviceLevelList;
        this.gridContext = {
          ...this.gridContext,
          newShipments: this.props.IBPlanningStore.newShipments,
          specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(
            this.serviceLevelList,
            [],
            appConstant.gridNames.StopsGrid
          ),
          maxWaitingTimeAtStop: this.props.CommonStore.maxWaitingTimeAtStop,
          enableFMECustomer: this.props.configJSON?.enableFMECustomer,
          enableTailLoad: this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement),
          routesList: this.props.IBPlanningStore.routesList
        };
      }
    });
    this.autorunWaitingTimeAtStop = autorun(() => {
      if (
        this.maxWaitingTimeAtStop !==
        this.props.CommonStore.maxWaitingTimeAtStop
      ) {
        this.maxWaitingTimeAtStop = this.props.CommonStore.maxWaitingTimeAtStop;
        this.gridContext = {
          ...this.gridContext,
          newShipments: this.props.IBPlanningStore.newShipments,
          specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(
            this.serviceLevelList,
            [],
            appConstant.gridNames.StopsGrid
          ),
          maxWaitingTimeAtStop: this.props.CommonStore.maxWaitingTimeAtStop,
          enableFMECustomer: this.props.configJSON?.enableFMECustomer,
          enableTailLoad: this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement),
          routesList: this.props.IBPlanningStore.routesList
        };
      }
    });
    this.routeToTrailerMapDispose = reaction(
      () => ({
        routeWithTrailerName: this.props.IBPlanningStore.routeWithTrailerName,
        trailerInfo: this.props.CommonStore.trailerInfo
      }),
      () => {
        this.refreshViolationColumn();
      }
    );
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      appConstant.Event.STOP_SELECTED_MAP,
      this.stopSelected
    );
    this.props.glEventHub.off(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.off(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_mergeStops`,
      this.confirmMergeStop
    );
    this.onCloseFeedbackPanel();
    this.autorunNewShipmentsDispose?.();
    this.updateDragStateDispose?.();
    this.autorunPriorityShipmentList?.();
    this.autorunWaitingTimeAtStop?.();
    this.routeToTrailerMapDispose?.();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.gridContext.planDate = this.props.userData.userProfile.planDate;
    }
    if (this.props.featureFlags !== prevProps.featureFlags) {
      this.gridContext.enableTailLoad = this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement);
    }
  }

  hasEquipmentMismatch = (stop) => {
    if (!stop.routeId || stop.stopType === 'AP') return false;
    const route = this.props.IBPlanningStore.getRoute(stop.routeId);
    if (!route) return false;
    const trailer = this.props.CommonStore.availableTrailers.find(
      (trailer) => trailer.trailerId === route?.trailerId
    );
    if (!trailer) return false;
    return isEquipmentMismatch(trailer, stop);
  };

  hasAnchorPointEquipmentMismatch = (stop) => {
    if (!stop.routeId || stop.stopType !== 'AP') return false;
    const route = this.props.IBPlanningStore.getRoute(stop.routeId);
    if (!route) return false;
    const trailer = this.props.CommonStore.availableTrailers.find(
      (trailer) => trailer.trailerId === route?.trailerId
    );
    if (!trailer) return false;
    return isAnchorPointEquipmentMismatch(trailer, stop);
  };

  onCancelMergeStops = () => {
    this.setState({ mergeStopInProgress: false });
  };

  onCancelMergeStopAlert = () => {
    this.setState({ showMergeStopAlert: false });
  };

  onConfirmMergeStopAlert = () => {
    this.setState({ showMergeStopAlert: false, mergeStopInProgress: true });
  };

  confirmMergeStop = () => {
    const {trimbleMapsDirectionConfig = {}} = this.props;
    if (this.state.selectedStops.length === 2) {
      MapHelper.getDistance([
        [
          this.state.selectedStops[0].longitude,
          this.state.selectedStops[0].latitude,
        ],
        [
          this.state.selectedStops[1].longitude,
          this.state.selectedStops[1].latitude,
        ],
      ], trimbleMapsDirectionConfig).then((distanceData) => {
        if (parseInt(distanceData.distance) > 1) {
          this.setState({ showMergeStopAlert: true });
        } else {
          this.setState({ mergeStopInProgress: true });
        }
      });
    }
  };

  refreshViolationColumn = () => {
    if (this.gridApi.refreshCells) {
      this.gridApi.refreshCells({ columns: ["violation"], force: true });
    }
    if (this.state.filterData && this.gridApi.onFilterChanged) {
      this.gridApi.onFilterChanged();
    }
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };

  stopSelected = (routeStopId) => {
    if (this.gridApi) {
      this.stopSelectedOnGrid = false;
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (node.data.routeStopId === routeStopId) {
          node.setSelected(true, false, true);
          this.gridApi.ensureIndexVisible(node.rowIndex);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.resizeRouteColumn({api});
    this.gridApi.selectedRouteNameList =
      this.props.IBPlanningStore.selectedRouteNameList;
    if (this.gridApi.selectedRouteNameList.length === 1) {
      this.gridApi.redrawRows();
    }
  };

  resizeRouteColumn = ({api}) => {
    api.autoSizeColumns(["routeName"])
  }

  onSelectionChanged = () => {
    if (this.gridApi && this.stopSelectedOnGrid) {
      const selectedStops = this.gridApi
        .getSelectedRows()
        ?.map((stop) => ({ ...stop, key: uuidv4() }));
      this.props.glEventHub.emit(
        appConstant.Event.STOP_SELECTED_GRID,
        selectedStops.map((stop) => stop.routeStopId)
      );
      this.props.glEventHub.emit(
        `${this.gridHeaderId}_EnableMergeStops`,
        this.shouldEnableMergeStopIcon(selectedStops)
      );
      this.setState({ selectedStops });
    }
  };

  shouldEnableMergeStopIcon = (selectedStops) => {
    let message = "",
      enableMerge = false;
    const isSelectedStopsContainPickup = selectedStops.some((stop) =>
      isPickupStop(stop.stopType)
    );
    this.isPickupStopMergeFlow = isSelectedStopsContainPickup;
    if (selectedStops.length < 2) {
      return { message: "Select at least two stops to merge.", enableMerge };
    } else if (selectedStops.length > 2) {
      return { message: "Only 2 stops can be merged at a time.", enableMerge };
    } 
    const isSelectedStopsContainTrapRoutesStop = selectedStops.some((stop) => stop.isTrapRoute);
    if (isSelectedStopsContainTrapRoutesStop) {
      return { message: "Stops on trap routes cannot be merged with stops on non-trap routes.", enableMerge }
    } 
    const isSelectedStopsContainDelivery = selectedStops.some((stop) =>
      isDeliveryStop(stop.stopType)
    );
    if (isSelectedStopsContainPickup && isSelectedStopsContainDelivery) {
      return { message: "Pickup and delivery stops can't be merged together.", enableMerge };
    } else if (isSelectedStopsContainPickup) {
      return { message: "Pickup stops cannot be merged.", enableMerge };
    }
    return {
      message,
      enableMerge: true,
    };
  };

  onCellClicked = () => {
    this.stopSelectedOnGrid = true;
  };

  onRowDragEnter = (params) => {
    this.intialSequenceState = {};
    this.props.IBPlanningStore.filteredRouteStops.map(
      (stop) => (this.intialSequenceState[stop.routeStopId] = stop.stopSequence)
    );
    this.addThemeClassToGhostItem();
  };

  addThemeClassToGhostItem = () => {
    Array.from(document.getElementsByClassName("ag-dnd-ghost")).forEach(
      (item) => item.classList.add(`theme-${this.props.theme.themeName}`)
    );
  };

  onRowDragLeave = (params) => {
    // If dragging moves the stop out of the grid reset it back to default position
    // because once outside the grid we don't know when a user drops the stop
    const sortedData = this.props.IBPlanningStore.filteredRouteStops
      .slice()
      .sort((stop1, stop2) => stop1.stopSequence - stop2.stopSequence);
    
    this.updateGridRowData(sortedData);
    this.gridApi.redrawRows();
  };

  onRowDragEnd = (params) => {
    const rowData = [];
    params.api.forEachNodeAfterFilterAndSort(node => {
      if (node?.data) rowData.push(cloneDeep(node.data));
    });

    rowData.forEach((row, i) => {
      row.stopSequence = i + 1;
    });

    if (this.isSequenceChanged(rowData, this.intialSequenceState)) {
      this.isDragOperationInProgress = true;
      this.props.glEventHub.emit("UpdateIBStore", "setReseqeuncedRouteStops", [
        rowData.sort((stop1, stop2) => stop1.stopSequence - stop2.stopSequence),
      ]);
      this.updateStopSequence();
      this.gridApi.redrawRows(); // needed to update the hover item when row is dragged next
      this.stopSelected(params.node.data.routeStopId);
    }
  };

  onRowDragMove = (event) => {
    let movingNode = event.node;
    let overNode = event.overNode;
    let stopsList = [];
    event.api.forEachNodeAfterFilterAndSort(node => {
      stopsList.push(node.data);
    });

    // Dont move node if next stop is Anchor point
    let rowNeedsToMove =
      movingNode !== overNode && overNode && overNode.data.stopType !== appConstant.ROUTE_STOP_TYPES.AP;
    if (rowNeedsToMove) {
      // the list of rows we have is data, not row nodes, so extract the data
      let movingData = movingNode.data;
      let overData = overNode ? overNode.data : null;

      let fromIndex = stopsList.indexOf(movingData);
      let toIndex = overData
        ? stopsList.indexOf(overData)
        : stopsList.length - 1;

      // update the grid row data in UI to show the movement of rows
      let updatedStopsList = stopsList.slice();
      moveInArray(updatedStopsList, fromIndex, toIndex);
      stopsList = updatedStopsList;
      this.updateGridRowData(updatedStopsList);
    }

    function moveInArray(arr, fromIndex, toIndex) {
      let element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }
  };

  isSequenceChanged = (updatedStops, intialSequenceState) => {
    const newSequence = {};
    updatedStops.map(
      (stop) => (newSequence[stop.routeStopId] = stop.stopSequence)
    );
    return (
      Object.keys(newSequence).findIndex(
        (key) => intialSequenceState[key] !== newSequence[key]
      ) >= 0
    );
  };
  // Listen for sort changed
  onSortChanged = () => {
    const sortModel = this.gridApi.getColumnState()
      .filter(col => col.sort);
    this.sortActive = sortModel?.length > 0;
    this.updateGridRowDragState();
  };
  // listen for changes on filter changed
  onFilterChanged = () => {
    this.filterActive = this.gridApi.isAnyFilterPresent();
    // During row drag: disableStoreUpdate is set to true, which triggers autorun to suppress row drag.
    // After drag, store updates trigger rowDataUpdated → filterManager.onNewRowsLoaded() → onFilterChanged.
    // We skip this duplicate updateGridRowDragState call and reset the flag.
    if (!this.isDragOperationInProgress) {
      this.updateGridRowDragState();
    } else {
      this.isDragOperationInProgress = false;
    }
  };

  // disable rowDrag when  anyFilter is applied or sorting is done on the grid
  updateGridRowDragState = (forceSupressRowDrag) => {
    const suppressRowDrag = Boolean(
      this.sortActive || this.filterActive || forceSupressRowDrag
    );
    this.gridApi.setGridOption("suppressRowDrag", suppressRowDrag);
  };

  updateGridRowData = (rowData) => {
    this.gridApi.setGridOption("rowData", rowData);
    this.gridApi.clearFocusedCell();
  };

  // Required for deltaRowDataMode
  getRowId = ({data}) => {
    return data.routeStopId;
  };

  getUpdatedStopSequenceRequest = () => {
    const currentRoute = this.props.IBPlanningStore.filteredRouteStops[0];
    return {
      scenarioId: this.props.userData.userProfile.scenarioID,
      routeId: currentRoute.routeId,
      routeName: currentRoute.routeName,
      stops: this.props.IBPlanningStore.filteredRouteStops.map((stop) => ({
        routeStopId: stop.routeStopId,
        sequence: stop.stopSequence,
        isLastStop:
          this.intialSequenceState[stop.routeStopId] === stop.stopSequence
            ? stop.isLastStop
            : false,
        isFirstStop:
          this.intialSequenceState[stop.routeStopId] === stop.stopSequence
            ? stop.isFirstStop
            : false,
      })),
    };
  };

  // Update Stop sequence by calling API's
  updateStopSequence = () => {
    this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [
      true,
    ]);
    const updatedStopSequence = this.getUpdatedStopSequenceRequest();
    this.props.closeSnackbar(); //Closes other snackbars
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_updateMessage`,
      "Saving stop sequence"
    );
    const [successRoutes, failureRoutes] = [[], []];
    postData("UpdateStopSequence", updatedStopSequence)
      .then(
        (response) => {
          if (response && Math.trunc(response.status / 100) === 2) {
            // Will handle success and failure once api is ready
            if (response.data && response.data.routes) {
              response.data.routes.map((route) => {
                if (route.success) {
                  successRoutes.push(route.routeName);
                } else {
                  failureRoutes.push(route.routeName);
                }
              });
            }
            this.handleStopResequencedFeedbackData(
              response,
              successRoutes,
              failureRoutes
            );
            if (failureRoutes.length > 0) {
              this.props.enqueueSnackbar(
                `Optimization failed for routes ${failureRoutes.join(", ")}`,
                { variant: "error" }
              );
            } else {
              this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.SUCCESS, {
                variant: "success",
              });
            }
            this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [{
                showNotification: false,
                selectedRoutesList:  this.props.IBPlanningStore.selectedRouteNameList
              }
            ]);
            this.props.glEventHub.emit(
              `${this.gridHeaderId}_updateMessage`,
              null
            );
          } else {
            this.handleUpdateStopSequenceError(
              response?.response?.status ?? response.status
            );
          }
        },
        (error) => {
          this.handleUpdateStopSequenceError();
          console.log(MESSAGES.STOP_MOVE.FAILURE, JSON.stringify(error));
        }
      )
      .then(() => {
        //Log telemetry
        const eventSpecificData = {
          routes: [...successRoutes, ...failureRoutes].join(", "),
        };
        RMAXLogger.info(
          "StopMoveWithInRoutesOnGrid",
          eventSpecificData
        );
      });
  };

  handleUpdateStopSequenceError = (statusCode) => {
    if (statusCode !== 403) {
      this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.FAILURE, {
        variant: "error",
      });
    }
    this.props.glEventHub.emit(`${this.gridHeaderId}_updateMessage`, null);
    if (statusCode !== 409) {
      this.props.glEventHub.emit("UpdateIBStore", "refreshFilterStops", []);
      this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
    }
  };  

  handleStopResequencedFeedbackData = (
    response,
    successRoutes,
    failureRoutes
  ) => {
    if (response.data.feedback) {
      const feedbackData = {
        ...response.data.feedback,
        routesAffected: [...successRoutes, ...failureRoutes].join(", "),
        scenarioVersionId: response.data.scenarioVersionId,
        scenarioId: this.props.userData.userProfile.scenarioID,
      };

      this.feedbackPanelKey = this.props.enqueueSnackbar("Stop Resequenced", {
        children: (
          <StopMoveFeedbackPanel
            open
            moveType={appConstant.STOP_MOVES.RESEQUENCE}
            data={feedbackData}
            onClose={this.onCloseFeedbackPanel}
            refreshData={this.refreshData}
            glEventHub={this.props.glEventHub}
          />
        ),
        autoHideDuration: 30000,
      });
    }
  };
  //When a cell value is Changed
  onCellValueChanged = (params) => {
    const field = params.colDef.field;
    const value = params.value;
    const stopList = [
      {
        ...params.data,
        routeName:
          field === "routeName" ? params.oldValue : params.data.routeName,
      },
    ];

    if (this.isUpdateValid({ stopList, field, value, currentCell: params })) {
      this.stopBackupData = {};
      this.stopBackupData[params.data.routeStopId] = {
        [field]: params.oldValue,
      };
      this.updateStopInfo({ stopList, field, value });
    } else {
      params.data[field] = params.oldValue;
      this.gridApi.refreshCells({ columns: [field], force: true });
    }
  };

  //handle bulk update case
  onBulkUpdate = ({ field, newValue }) => {
    const stopList = this.gridApi
      .getSelectedRows()
      .filter((stop) => stop.stopType !== appConstant.ROUTE_STOP_TYPES.AP)
      .map((stop) => ({ ...stop }));
    let currentCell = null;
    if (stopList.length === 1) {
      currentCell = {
        oldValue: this.gridApi.getSelectedRows()[0][field],
      };
    }
    if (
      this.isUpdateValid({
        stopList,
        field,
        value: newValue,
        currentCell,
        isBulkEdit: true,
      })
    ) {
      this.updateStopUI({ stopList, field, value: newValue });
      this.updateStopInfo({ stopList, field, value: newValue });
    }
  };

  isUpdateValid = ({ stopList, field, value, currentCell, isBulkEdit }) => {
    // get list of unique trap route names from selected stops
    const trapRouteStops = this.gridApi
      .getSelectedRows()
      .filter((stop) => stop.stopType !== appConstant.ROUTE_STOP_TYPES.AP && stop.isTrapRoute);
    const trapRouteValues = trapRouteStops.length ? [currentCell.oldValue] : [];
    const trapRoutes = isBulkEdit
      ? [...new Set(trapRouteStops.map((stop) => stop.routeName))]
      : trapRouteValues;
    if (stopList.length === 0) {
      this.props.enqueueSnackbar(MESSAGES.STOP_UPDATE.NO_STOP_SELECTED, {
        variant: "error",
      });
      return false;
    } else if (trapRoutes.length > 0) {
      this.props.enqueueSnackbar(
        `Cannot move out stops from Trap route${
          trapRoutes.length > 1 ? "s" : ""
        } ${trapRoutes.join(",")}`,
        { variant: "error" }
      );
      return false;
    }
    let isUpdateValid = true;
    switch (field) {
      case "routeName":
        if (!value) {
          this.props.enqueueSnackbar(MESSAGES.STOP_UPDATE.ROUTE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (value.label === appConstant.UNRTD_ROUTENAME) {
          this.props.enqueueSnackbar(MESSAGES.STOP_UPDATE.ROUTE_UNRTD, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value.label) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        } else {
          const gloveRouteError = handleWhiteGloveProMove({
            shipments: stopList,
            routeName: value.label,
            snackbar: this.props.enqueueSnackbar
          });
          if (gloveRouteError) {          
            isUpdateValid = false;
          }
        }
        break;
      default:
        if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
    }
    return isUpdateValid;
  };

  // Updates the UI (which in turn will updated the store) to display updated values & creates a backup of existing values for restore on failure
  updateStopUI = ({ stopList, field, value }) => {
    this.stopBackupData = {};
    const stopIdList = stopList.map((stop) => stop.routeStopId);
    this.gridApi.getSelectedRows().map((stop) => {
      if (stopIdList.includes(stop.routeStopId)) {
        this.stopBackupData[stop.routeStopId] = {
          [field]: stop[field],
        };
        stop[field] = value;
      }
    });
    this.gridApi.refreshCells();
  };

  // Updates the UI(which in turn will updated the store) to the value available from backup
  restoreStopsData = ({ stopList, field }) => {
    const stopIdList = stopList.map((stop) => stop.routeStopId);
    this.gridApi.forEachNode((node) => {
      if (stopIdList.includes(node.data.routeStopId)) {
        node.data[field] = this.stopBackupData[node.data.routeStopId][field];
      }
    });
    this.gridApi.refreshCells();
  };

  getCustomerIdToUpdate = (stop) => {
    return isPickupStop(stop.stopType)
      ? {
          idFieldName: "rmaxShipperCode",
          fieldValue: stop.rmaxShipperCode,
        }
      : { idFieldName: "customerId", fieldValue: stop.consigneeId };
  };

  getRequestParams = ({ stopList, field, value }) => {
    let requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    if (field === "routeName") {
      const routeData = this.props.IBPlanningStore.routesList.find(
        (route) => route.routeName === value.label
      );
      requestParams.routeId = value.isNewValue ? null : value.value;
      requestParams.routeName = value.label;
      requestParams.isTrapRoute = routeData ? routeData.isTrapRoute : false;
      requestParams.stops = stopList.map((stop) => {
        const { idFieldName, fieldValue } = this.getCustomerIdToUpdate(stop);
        return {
          routeId: stop.routeId,
          routeName: stop.routeName,
          sequence: stop.stopSequence,
          [idFieldName]: fieldValue,
        };
      });
    } else if (field === "stopTime") {
      requestParams.stops = stopList.map((stop) => {
        const { idFieldName, fieldValue } = this.getCustomerIdToUpdate(stop);
        return {
          routeId: stop.routeId,
          [field]: value,
          [idFieldName]: fieldValue,
          routeName: stop.routeName,
        };
      });
    } else {
      requestParams.stops = stopList.map((stop) => ({
        routeStopId: stop.routeStopId,
        [field]: value,
      }));
    }
    return requestParams;
  };

  refreshData = () => {
    this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [{
      showNotification: false,
      selectedRoutesList:  this.props.IBPlanningStore.selectedRouteNameList
    }]);
  };
  updateStopInfo = ({ stopList, field, value }) => {
    const requestParams = this.getRequestParams({ stopList, field, value });
    this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [
      true,
    ]);
    this.props.glEventHub.emit(`${this.gridHeaderId}_DisableEditSave`, true);
    this.props.closeSnackbar(); //Closes other snackbars
    const [successRoutes, failureRoutes] = [[], []];
    const requestURL =
      field == "stopTime" ? "UpdateRouteStopTime" : "UpdateRouteStops";
    postData(requestURL, requestParams)
      .then(
        (response) => {
          if (response && Math.trunc(response.status / 100) === 2) {
            if (field === "routeName") {
              if (response.data && response.data.routes) {
                response.data.routes.forEach((stopRoute) => {
                  if (stopRoute.success) {
                    successRoutes.push(stopRoute.routeName);
                  } else {
                    failureRoutes.push(stopRoute.routeName);
                  }
                });
              }

              this.handleFeedBackData(response, successRoutes, failureRoutes);
              this.handleFailureRoute(response, failureRoutes);

              this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [{
                showNotification: false,
                selectedRoutesList:  this.props.IBPlanningStore.selectedRouteNameList
              }]);
            } else {
              this.props.enqueueSnackbar(MESSAGES.STOP_UPDATE.STOP_TIME, {
                variant: "success",
              });
              this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [{
                showNotification: false,
                selectedRoutesList:  this.props.IBPlanningStore.selectedRouteNameList
              }]);
            }
            this.props.glEventHub.emit(
              `${this.gridHeaderId}_showEditMode`,
              false
            );
            this.props.glEventHub.emit(
              `${this.gridHeaderId}_DisableEditSave`,
              false
            );
          } else {
            this.handleErrorInUpdateStop({
              stopList,
              field,
              errorResponse: response?.response
            });
          }
        },
        (error) => {
          this.handleErrorInUpdateStop({stopList, field});
          console.log(MESSAGES.STOP_MOVE.FAILURE, JSON.stringify(error));
        }
      )
      .then(() => {
        //Log telemetry
        const eventSpecificData = {
          routes: [...successRoutes, ...failureRoutes].join(", "),
        };
        RMAXLogger.info(
          "StopMoveBetweenRoutesOnGrid",
          eventSpecificData
        );
      });
  };

  handleErrorInUpdateStop = ({stopList, field, errorResponse}) => {
    if (errorResponse?.status !== 403) {
      const errorMessage = errorResponse?.data?.error?.message || MESSAGES.STOP_MOVE.FAILURE;
      this.props.enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    }
    this.restoreStopsData({ stopList, field });
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_DisableEditSave`,
      false
    );
    if (errorResponse?.status !== 409) {
      this.props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [
        false,
      ]);
    }
  };

  handleFeedBackData = (response, successRoutes, failureRoutes) => {
    if (response.data.feedback) {
      const feedbackData = {
        ...response.data.feedback,
        routesAffected: [...successRoutes, ...failureRoutes].join(", "),
        scenarioVersionId: response.data.scenarioVersionId,
        scenarioId: this.props.userData.userProfile.scenarioID,
      };

      this.feedbackPanelKey = this.props.enqueueSnackbar("Stop Route Changed", {
        children: (
          <StopMoveFeedbackPanel
            open
            moveType={appConstant.STOP_MOVES.CHANGE_ROUTE}
            data={feedbackData}
            onClose={this.onCloseFeedbackPanel}
            refreshData={this.refreshData}
            glEventHub={this.props.glEventHub}
          />
        ),
        autoHideDuration: 30000,
      });
    }
  };
  handleFailureRoute = (response, failureRoutes) => {
    if (failureRoutes.length > 0) {
      this.props.enqueueSnackbar(
        `Optimization failed for routes ${failureRoutes.join(", ")}`,
        { variant: "error" }
      );
    } else {
      this.props.enqueueSnackbar(MESSAGES.STOP_MOVE.SUCCESS, {
        variant: "success",
      });
    }
  };

  onCloseFeedbackPanel = () => {
    if (this.feedbackPanelKey !== null) {
      this.props.closeSnackbar(this.feedbackPanelKey);
      this.feedbackPanelKey = null;
    }
  };

  rowDataUpdated = () => {
    // When deltaRowDataMode={true}, rowDataUpdated is called instead of rowDataChanged
    // but the filters dont get lastest data since onNewRowsLoaded is called only on rowDataChanged
    // So inorder to upadate the filters we are explicity calling onNewRowsLoaded method here
    this.refreshViolationColumn();
    if (
      this.gridApi &&
      this.gridApi.clientSideRowModel &&
      this.gridApi.clientSideRowModel.filterManager
    ) {
      this.gridApi.clientSideRowModel.filterManager.onNewRowsLoaded({
        api: this.gridApi,
      });
    }
  };
  

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "MissedApt":
        return this.getStopStatus(node.data) === appConstant.STOP_STATUS.DELAYED;
      case "LateShipments":
        return Boolean(
          CheckViolation.checkPrepTimeGreaterThanStartTime({
            data: node.data,
            planDate: this.props.userData.userProfile.planDate,
          })
        );
      case "NewPros":
        return Boolean(
          CheckViolation.checkNewProsInStop({
            data: node.data,
            context: this.gridContext,
          })
        );
      default:
        return true;
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  getStopStatus = (stop) => {
    return StopStatusCellRenderer({
      data: stop,
      context: this.gridContext,
    });
  };

  constructStatusBar = (stopsList) => {
    const delayedAptCount =
      stopsList.length > 0
        ? stopsList
            .map((stop) => this.getStopStatus(stop))
            .filter((stopStatus) =>  stopStatus === appConstant.STOP_STATUS.DELAYED).length
        : 0;
    const lateProsCount = stopsList
      ? stopsList
          .map((stops) =>
            Boolean(
              CheckViolation.checkPrepTimeGreaterThanStartTime({
                data: stops,
                planDate: this.props.userData.userProfile.planDate,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    const newProsCount = stopsList
      ? stopsList
          .map((stops) =>
            Boolean(
              CheckViolation.checkNewProsInStop({
                data: stops,
                context: this.gridContext,
              })
            )
          )
          .filter((value) => value).length
      : 0;
    const statusBarData = [
      {
        label: stopsList.length + " Stops",
        filterCondition: "",
      },
      {
        label: delayedAptCount + " Missed Apts",
        filterCondition: "MissedApt",
      },
      {
        label: newProsCount + " New",
        filterCondition: "NewPros",
      },
      {
        label: lateProsCount + " Arriving Late",
        filterCondition: "LateShipments",
      },
    ];
    return statusBarData;
  };

  render() {
    const stopsList =
      this.props.IBPlanningStore.filteredRouteStops.length > 0
        ? this.props.IBPlanningStore.filteredRouteStops.slice()
        : [];

    return (
      <Fragment>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={stopsList}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged}
          onCellClicked={this.onCellClicked}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
              filterGridData={this.updateGridData}
            />
          )}
          quickFilterText={this.state.quickFilterText}
          onCellValueChanged={this.onCellValueChanged}
          suppressRowClickSelection={this.state.showMergeStopAlert}
          onFirstDataRendered={this.resizeRouteColumn}
          onRowDragEnter={this.onRowDragEnter}
          onRowDragEnd={this.onRowDragEnd}
          onRowDragLeave={this.onRowDragLeave}
          onRowDragMove={this.onRowDragMove}
          onSortChanged={this.onSortChanged}
          onFilterChanged={this.onFilterChanged}
          deltaRowDataMode={true} // executes change as update transaction, keeping all of grids selection, filters etc
          getRowId={this.getRowId}
          layoutContainer={this.props.glContainer}
          onRowDataUpdated={this.rowDataUpdated}
          accentedSort={true}
          isExternalFilterPresent={() => Boolean(this.state.filterData)}
          doesExternalFilterPass={this.doesExternalFilterPass}
          context={this.gridContext}
          showErrorMessage={this.props.IBPlanningStore.stopGridMessage}
        />

        {this.state.showMergeStopAlert && (
          <MergeStopAlert
            onCancel={this.onCancelMergeStopAlert}
            onConfirm={this.onConfirmMergeStopAlert}
          />
        )}
        {this.state.mergeStopInProgress && (
          <MergeStops
            open
            onClose={this.onCancelMergeStops}
            selectedStops={this.state.selectedStops}
            glEventHub={this.props.glEventHub}
            mergeType={MERGE_TYPES.Stops}
            isPickupStopMergeFlow={this.isPickupStopMergeFlow}
          />
        )}
      </Fragment>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withUserProfile,
  withSnackbar,
  withFeatureFlags,
  withAppConfig,
  withMapConfig
)(StopsGrid);
